import { render, staticRenderFns } from "./windowCardsPosters.vue?vue&type=template&id=6e41a5e7&"
import script from "./windowCardsPosters.vue?vue&type=script&lang=js&"
export * from "./windowCardsPosters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports